/**
 * フリーテキストの指示が「既存バナーの手直し」に見えるかを判定する。
 *
 * 本番分析（2026-09-22）では、手直しの約7割が編集機能ではなくフリーテキストで
 * バナー全体を作り直す経路で行われていた。生成済みバナーを参照画像にして
 * 手直しっぽい指示を書いたときに、編集機能・マジックリサイズを案内するための判定。
 * 案内は閉じられるので、取りこぼしより誤検出を少し許容する作り。
 *
 * 2026-09-23 計測（本番のフリーテキスト依頼のうち参照画像付き、Jev の作業タイプ分類を正解とする）:
 * 手直しの約68%を拾い、拾ったものの約85%が手直し。新規作成を誤って拾う割合は約9%。
 * パターンを足すときは、この3つの数字が悪化しないかを同じデータで確かめる。
 */
export type TouchUpIntent = 'edit' | 'resize';

/** これより長い指示は新規作成のブリーフとみなし、手直し判定をしない */
export const TOUCH_UP_MAX_LENGTH = 300;

const RESIZE_PATTERNS: RegExp[] = [
  /リサイズ/,
  /サイズ(?:を)?(?:変更|違い|展開|調整)/,
  /(?:縦長|横長|縦型|横型)(?:に|へ|版|の|バージョン)/,
  /\d{2,4}\s*[x×X＊*]\s*\d{2,4}\s*(?:px)?\s*(?:に|へ|で|サイズ)/,
];

const EDIT_PATTERNS: RegExp[] = [
  /削除/,
  /消して|消す|トルツメ/,
  /差し替え|差替|入れ替え|入れかえ/,
  /(?:に|を)変更|変更して/,
  /(?:に|を)変えて/,
  /修正/,
  /直して/,
  /[→⇒]/,
  /を追加|追加して/,
  /足して/,
  /移動/,
  /もっと(?:大きく|小さく|目立|上|下|左|右|明るく|暗く)/,
  /色を|フォント|文字(?:の)?(?:サイズ|大きさ|色)/,
];

export function detectTouchUpIntent(text: string): TouchUpIntent | null {
  const t = text.trim();
  if (!t || t.length > TOUCH_UP_MAX_LENGTH) return null;
  if (RESIZE_PATTERNS.some((p) => p.test(t))) return 'resize';
  if (EDIT_PATTERNS.some((p) => p.test(t))) return 'edit';
  return null;
}
